module.exports = __webpack_public_path__ + "img/Character-sitting.10c32770.png";